import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { appSettings } from '../../../../modules/shared/components/appSettings';
import { AppSettings } from '../../../../entities/AppSettings';

@Component({
  selector: 'app-req-item-excel-import',
  templateUrl: './req-item-excel-import.component.html',
  styleUrls: ['./req-item-excel-import.component.css']
})
export class ReqItemExcelImportComponent implements OnInit {

  private requisitionId: any;
  public loading: boolean = false;
  public canSubmitImport: boolean;
  public uploadedFilename: any;
  public validationsLoaded: boolean;
  public validations: any;
  public appSettings: AppSettings = appSettings;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
    private apiService: ApiService,
    private messageService?: NbToastrService) {
    if (config && config.data && config.data.requisitionId) {
      this.requisitionId = config.data.requisitionId;
    }



  }

  ngOnInit() {
  }

  downloadTemplate() {
    const link = document.createElement('a');
    link.href = `${appSettings.apiServiceAddress}/api/fileServe/templates/ReqItemImport.xlsx`;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  onBeforeSend(event) {
    var errors = new Array();
    this.loading = true;
    //event.xhr.setRequestHeader("Authorization", `Bearer ${this.authService.access_token}`);
  }

  onProgress(event) {
  }

  onUploadError(event) {
    this.messageService.danger("Could not upload file", "Action");
    this.canSubmitImport = false;
    this.loading = false;
  }

  onBasicUploadAuto(data) {
    this.messageService.success("Uploaded file", "Action");
    this.uploadedFilename = data.originalEvent.body.filename;
    this.validateFileData();
    this.canSubmitImport = false;
  }

  validateFileData() {
    this.messageService.info("Validation of file started", "Action");
    this.validationsLoaded = false;
    this.loading = true;
    this.apiService.get(`/api/requisitionItem/validateImport/${this.requisitionId}/${this.uploadedFilename}`)
      .subscribe(validations => {
        this.validations = validations;
        this.messageService.success("File validated", "Action");
        this.loading = false;
        this.canSubmitImport = this.validations.filter(o => o.error).length == 0;
        this.validationsLoaded = true;
      }, error => {
        this.messageService.danger("Could not validate file", "Action");
        this.loading = false;
      });
  }

  importData() {
    this.loading = true;
    this.apiService.get(`/api/requisitionItem/importData/${this.requisitionId}/${this.uploadedFilename}`)
      .subscribe(validations => {
        this.validations = validations;
        this.messageService.success("File imported", "Action");
        this.loading = false;
        this.canSubmitImport = false;
        this.validationsLoaded = false;
        this.ref.close(true);
      }, error => {
        this.messageService.danger("Could not import file", "Action");
        this.loading = false;
      });
  }
}
